import { requestWithToken } from '../utilities/request';
const path = '/api/private/fields';

const list = (fieldId, param) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldId}/gate_passages/list`),
    params: param,
    isQuiet: param.isQuiet || false,
  });
};

const updateList = (fieldId, param) => {
  return requestWithToken({
    method: 'PATCH',
    url: path.concat(`/${fieldId}/gate_passages/list`),
    data: param,
  });
};

const total = (fieldId, param) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldId}/gate_passages/list_total`),
    params: param,
  });
};

const create = (fieldId, param) => {
  return requestWithToken({
    method: 'POST',
    url: path.concat(`/${fieldId}/gate_passages`),
    data: param,
    validateStatus(status) {
      // Reject only if the status code 400
      return status === 400 || status === 200;
    },
  });
};

const copy = (fieldId, param) => {
  return requestWithToken(
    {
      method: 'POST',
      url: path.concat(`/${fieldId}/gate_passages/copy`),
      data: param,
      validateStatus(status) {
        // Reject only if the status code 400
        return status === 400 || status === 200;
      },
    },
    false
  );
};

/**
 * ログイン中の番頭・職長ユーザーが登録した機材予定データの履歴取得
 * @param fieldId {int}
 * @param param {object}
 */
const registrationHistoryList = (fieldId, param) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldId}/gate_passages/registration_history_list`),
    params: param,
  });
};

/**
 * ゲート予定論理削除
 * @param fieldId {int}
 * @param id {int}
 */
const deleteSchedule = (fieldId, id) => {
  return requestWithToken({
    method: 'DELETE',
    url: path.concat(`/${fieldId}/gate_passages/${id}`),
  });
};

/**
 * ゲート予定更新
 * @param fieldId {int}
 * @param id {int}
 * @param param {object}
 */
const update = (fieldId, id, param) => {
  return requestWithToken({
    method: 'PATCH',
    url: path.concat(`/${fieldId}/gate_passages/${id}`),
    data: param,
    validateStatus(status) {
      // Reject only if the status code 400
      return status === 400 || status === 200;
    },
  });
};

/**
 * ゲージを動かした際のゲート予定更新
 * @param fieldId {int}
 * @param id {int}
 * @param param {object}
 */
const gageUpdate = (fieldId, id, param) => {
  return requestWithToken(
    {
      method: 'PATCH',
      url: path.concat(`/${fieldId}/gate_passages/passage_update/${id}`),
      data: param,
      validateStatus(status) {
        // Reject only if the status code 400
        return status === 400 || status === 200;
      },
    },
    false
  );
};

/**
 * ゲート予定に揚重機を追加した場合の追加POST
 * @param fieldId {int}
 * @param id {int}
 * @param param {object}
 */
const addCraneUse = (fieldId, id, param) => {
  return requestWithToken({
    method: 'POST',
    url: path.concat(`/${fieldId}/gate_passages/crane_uses/${id}`),
    data: param,
    validateStatus(status) {
      // Reject only if the status code 400
      return status === 400 || status === 200;
    },
  });
};

/**
 * ゲート予定詳細取得
 * @param fieldId {int}
 * @param id {int}
 */
const show = (fieldId, id) => {
  return requestWithToken(
    {
      method: 'GET',
      url: path.concat(`/${fieldId}/gate_passages/${id}`),
    },
    false
  );
};

/**
 * ログイン中の番頭・職長ユーザーが前回登録したゲート予定データの履歴取得
 * @param fieldId {int}
 * @param param {object}
 */
const latestRegistration = (fieldId, param) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldId}/gate_passages/latest_registration`),
    params: param,
  });
};

/**
 * ゲート予定スポット業者履歴取得
 * @param fieldId {int}
 * @param param {object}
 */
const spotHistoryList = fieldId => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldId}/gate_passages/spot_history_list`),
  });
};

/**
 *
 * @param fieldId {int}
 * @param param {object}
 */
const getGateFleetSysRoutes = (fieldId, params) => {
  return requestWithToken({
    method: 'GET',
    url: `/api/private/fleet_mgmt/fields/${fieldId}/gate_fleet_system_routes`,
    params,
  });
};

/**
 *
 * @param fieldId {int}
 * @param param {object}
 */
const getListTransportationGroups = (fieldId, params) => {
  return requestWithToken({
    method: 'GET',
    url: `/api/private/fields/${fieldId}/gate_passages/transportation_groups`,
    params,
  });
};

export const GatePassageService = {
  list,
  updateList,
  total,
  create,
  copy,
  registrationHistoryList,
  deleteSchedule,
  update,
  gageUpdate,
  addCraneUse,
  show,
  latestRegistration,
  spotHistoryList,
  getGateFleetSysRoutes,
  getListTransportationGroups,
};

export default GatePassageService;



// WEBPACK FOOTER //
// ./src/services/GatePassages.js